import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { benchmarkkpi, tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpientry, benchmarkkpirelease, practicebmtransactionadd, benchmarkkpiposition, bmincoming, surveyOptionMaster, surveyOptionEntry, surveyQuestionMaster, surveyQuestionEntry, bmincomingattendees, bmdashboardFilterValue, BMProjectActions, BMIncomingSurveyEntry, bmsurveyQAList, BMProjectActionsHistory, annualPerformanceBM, annualPracticeBM, bmIncomingDashBoard, BMProjectApprovalHistroy, annualOutingVisit, outgoingBMRequest, bmRequest, incomingBMRequest, practiceBMGranttChart, bmsurveyQuestion, bmRequestStatusHistroy, bmInOutGoingStatusHistroy, bmoutgoing, annualStatusHistroy, bmOutgoingDashBoard, recentUpdates, dashboardContentEntry, dashboardChart, bmKPIPerformanceTrend, annualNomination, bmKPIPostionDashboard, kpiDynamic, year, kpiViewComment, kpitarget, kpiBulkCopy, quater, surveyConfig, filecontent, importtranbenchmarkkpi, delegatesHappinessMaster, slakpiInteraction, slakpiMapping, kpi } from './../models/slakpi';
import { division, user, department, targetMaster, benchmarkprogressmaster, fileManager, geographicArea, projectImportance } from './../models/admin';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BMApiService {
  // Define API
    headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.jwtToken() });
  apiURL = environment.apiBase; //'http://localhost:52180/';
  constructor(private http: HttpClient) { }
  /*========================================
  CRUD Methods for consuming RESTful API
  =========================================*/
  // Http Options
  private GetHttpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.jwtToken()
      })
    }
  }
  httpOptions_file = {
    headers: new HttpHeaders({
      'Authorization': 'Bearer ' + this.jwtToken()
    })
  };
  httpOptions_file_download = {
    responseType: "blob",
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.jwtToken()
    })
  }
  //JWT token access
  private jwtToken() {

    var struser = localStorage.getItem('accessinfo');
    if (struser) {
      let currentAccess = JSON.parse(struser);
      // create authorization header with jwt token           
      if (currentAccess && currentAccess.token) {
        //let headers = new Headers({ 'Authorization': 'Bearer ' + currentUser.token });
        return currentAccess.token;
      }
    }
  }
  _requestTextAPI(url: string, body: any) {

    let headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.jwtToken() });
    let options = { headers: headers, responseType: 'text' as 'json' };
    return this.http.post(url, body, options)
  }
  

  // Error handling 
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }


  public getUsers(objDepartment: user) {
    return this.http.post(this.apiURL + '/api/Admin/GetUser', objDepartment, this.GetHttpOptions());
  }

  public getDivisions(objDivision: division) {
    return this.http.post(this.apiURL + '/api/Admin/GetDivision', objDivision, this.GetHttpOptions());
  }
  public getDepartments(objDepartment: department) {
    return this.http.post(this.apiURL + '/api/Admin/GetDepartment', objDepartment, this.GetHttpOptions());
  }

  public GetTargetInfo(objDepartment: targetMaster) {
    
    return this.http.post(this.apiURL + '/api/BM/GetTargetInfo', objDepartment, this.GetHttpOptions());
  }

  //  API BenchMarkKPI Start here--------------------------GetBenchMarkKPI-------//


  public getBenchMarkKPIs(objKPI: benchmarkkpi) {
    return this.http.post(this.apiURL + '/api/BM/GetBenchMarkKPI', objKPI, this.GetHttpOptions());
  }

  public addEditBenchMarkKPI(objKPI: benchmarkkpi) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateBenchMarkKPI', objKPI, this.GetHttpOptions());
  }
  public deleteBenchMarkKPI(objKPI: benchmarkkpi) {
    return this.http.post(this.apiURL + '/api/BM/DeleteBenchMarkKPI', objKPI, this.GetHttpOptions());
  }

  public addEditTranBenchMarkKPI(objKPI: tranbenchmarkkpi) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateTranBenchMarkKPI', objKPI, this.GetHttpOptions());
  }

  public addEditBenchMarkKPIEntry(objKPI: benchmarkkpientry) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateBenchMarkKPIEntry', objKPI, this.GetHttpOptions());
  }
  public addEditBenchMarkKPIPosition(objKPI: benchmarkkpiposition) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateBenchMarkKPIPosition', objKPI, this.GetHttpOptions());
  }
  public getBenchMarkKPIPosition(objKPI: benchmarkkpiposition) {
    return this.http.post(this.apiURL + '/api/BM/GetBenchMarkKPIPosition', objKPI, this.GetHttpOptions());
  }
  public getBMPostionDashboard(obj: bmKPIPostionDashboard) {
    return this.http.post(this.apiURL + '/api/BM/GetBMPostionDashboard', obj, this.GetHttpOptions());
  }
  public addEditBenchMarkKPIRelease(objKPI: benchmarkkpirelease) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateBenchMarkKPIRelease', objKPI, this.GetHttpOptions());
  }
  public getBenchMarkKPIRelease(objKPI: benchmarkkpirelease) {
    return this.http.post(this.apiURL + '/api/BM/GetBenchMarkKPIRelease', objKPI, this.GetHttpOptions());
  }
  public getTranBenchMarkKPIs(objKPI: tranbenchmarkkpi) {
    return this.http.post(this.apiURL + '/api/BM/GetTranBenchMarkKPI', objKPI, this.GetHttpOptions());
  }
  public getTranBenchMarkKPIHistory(objKPI: tranbenchmarkkpihistory) {
    return this.http.post(this.apiURL + '/api/BM/GetTranBenchMarkKPIHistory', objKPI, this.GetHttpOptions());
  }
  public getBenchMarkKPIEntry(objKPI: tranbenchmarkkpi) {
    return this.http.post(this.apiURL + '/api/BM/GetBenchMarkKPIEntry', objKPI, this.GetHttpOptions());
  }
  public addEditTranBenchMarkKPI_Inbox(objKPI: tranbenchmarkkpi) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateTranBenchMarkKPIInbox', objKPI, this.GetHttpOptions());
  }
  public getBenchmarkKpiAttachment(objkpi: kpiDynamic) {
    return this.http.post(this.apiURL + '/api/BM/GetMstBMKPIAttachments', objkpi, this.GetHttpOptions());
  }
  public benchmarkKPIAttachmentUpload(objkpi: any) {
    return this.http.post(this.apiURL + '/api/BM/BenchmarkKPI_FileUpload', objkpi, this.httpOptions_file);
  }

  public getBenchmarkKpiInboxCount(objkpi: tranbenchmarkkpi) {

    return this.http.post(this.apiURL + '/api/BM/GetBenchmarkKPIInboxFilterCount', objkpi, this.GetHttpOptions());
  }

  public getBenchmarkKpiCodeDetails(objkpi: tranbenchmarkkpi) {
    return this.http.post(this.apiURL + '/api/BM/GetBenchMarkKPICodeDetails', objkpi, this.GetHttpOptions());
  }

  public getBMKPIPerformanceTrend(objkpi: bmKPIPerformanceTrend) {
    return this.http.post(this.apiURL + '/api/BM/GetBMKPIPerformanceTrend', objkpi, this.GetHttpOptions());
  }
  public sendBenchmarkReminderKPI(objslakpi: any) {
    return this.http.post(this.apiURL + '/api/BM/sendBenchmarkReminderKPI', objslakpi, this.GetHttpOptions());
  }
  public getKpiReminderComments(objkpi: kpiViewComment) {
    return this.http.post(this.apiURL + '/api/BM/GetKPIReminderComments', objkpi, this.GetHttpOptions());
  }

  //  API BenchMarkKPI End here---------------------------------//

  //BM Dashboard
  public getBMDashboard(objinpValue: bmdashboardFilterValue) {
    return this.http.post(this.apiURL + '/api/BM/GetBMDashboard', objinpValue, this.GetHttpOptions());
  }
  public getKPITranFilterValues(objyear: year) {
    return this.http.post(this.apiURL + '/api/BM/GetKPITranFilterValues', objyear, this.GetHttpOptions());
  }
  public getBMKPIInfo(objinpValue: bmdashboardFilterValue) {
    return this.http.post(this.apiURL + '/api/BM/getBMKPIInfo', objinpValue, this.GetHttpOptions());
  }
  //benchmark kpi target
  public addBenchmarkTarget(objkpiTarget: kpitarget) {

    return this.http.post(this.apiURL + '/api/BM/addBenchmarkTarget', objkpiTarget, this.GetHttpOptions());
  }
  public getBenchmarkTargets(objkpiTarget: kpitarget) {
    return this.http.post(this.apiURL + '/api/BM/getBenchmarkTargets', objkpiTarget, this.GetHttpOptions());
  }
  public bulkBenchmarkKPITargetProcess(objkpi: kpiBulkCopy) {
    return this.http.post(this.apiURL + '/api/BM/bulkBenchmarkKPITargetProcess', objkpi, this.GetHttpOptions());
  }
  public getYearMasterAll(objTenant: year) {
    return this.http.post(this.apiURL + '/api/Admin/GetYearMasterTenant', objTenant, this.GetHttpOptions());
  }
  //Recent Updated
  public getRecentUpdated(obj: recentUpdates) {
    return this.http.post(this.apiURL + '/api/BM/GetRecentUpdated', obj, this.GetHttpOptions());
  }
  public addRecentUpdates(obj: recentUpdates) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateRecentUpdates', obj, this.GetHttpOptions());
  }

  //BM Outgoinng

  public updateBMOutgoingStatus(obj: bmoutgoing) {
    return this.http.post(this.apiURL + '/api/BM/UpdateBMOutgoingStatus', obj, this.GetHttpOptions());
  }
  public getBMOutgoinng(objBMIncoming: any) {
    return this.http.post(this.apiURL + '/api/BM/GetBMOutgoinng', objBMIncoming, this.GetHttpOptions());
  }

  public getBMOutgoinngAtd(objBMIncoming: any) {
    return this.http.post(this.apiURL + '/api/BM/GetBMOutgoinngAtd', objBMIncoming, this.GetHttpOptions());
  }
  public getBMIncomingAtd(objBMIncoming: any) {
    return this.http.post(this.apiURL + '/api/BM/GetBMIncomingAtd', objBMIncoming, this.GetHttpOptions());
  }
  public addEditBMOutgoinng(objBMIncoming: any) {
    
    return this.http.post(this.apiURL + '/api/BM/AddEditBMOutgoinng', objBMIncoming, this.GetHttpOptions());
  }
  public getBMOutgoingDashboard(obj: bmOutgoingDashBoard) {
    return this.http.post(this.apiURL + '/api/BM/GetBMOutgoingDashboard', obj, this.GetHttpOptions());
  }

  //BM Incoming
  public fileManagerFileUpload(obj: any) {
    return this.http.post(this.apiURL + '/api/BM/FileManagerFileUpload', obj, this.httpOptions_file);
  }

  public getBMInOutGoingStatus(obj: bmInOutGoingStatusHistroy) {
    return this.http.post(this.apiURL + '/api/BM/GetBMInOutGoingStatus', obj, this.GetHttpOptions());
  }
  public updateBMIncomingStatus(obj: bmincoming) {
    return this.http.post(this.apiURL + '/api/BM/UpdateBMIncomingStatus', obj, this.GetHttpOptions());
  }
  public getBMIncoming(objBMIncoming: bmincoming) {
    return this.http.post(this.apiURL + '/api/BM/GetBMIncoming', objBMIncoming, this.GetHttpOptions());
  }

  public addEditBMIncoming(objBMIncoming: bmincoming) {
    
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateBMIncoming', objBMIncoming, this.GetHttpOptions());
  }
  public deleteBMIncoming(objBMIncoming: bmincoming) {
    return this.http.post(this.apiURL + '/api/BM/DeleteBMIncoming', objBMIncoming, this.GetHttpOptions());
  }
  public addEditBMIncomingSurveyQuestion(obj: bmincoming) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateBMIncomingSurveyQuestion', obj, this.GetHttpOptions());
  }
  public getBMIncomingSurveyQuestion(obj: bmsurveyQuestion) {
    return this.http.post(this.apiURL + '/api/BM/GetBMIncomingSurveyQuestion', obj, this.GetHttpOptions());
  }
  public getBMIncomingSurveyQAList(obj: bmsurveyQAList) {
    return this.http.post(this.apiURL + '/api/BM/GetBMIncomingSurveyQAList', obj, this.GetHttpOptions());
  }
  public getBMIncomingSurveyReport(obj: bmsurveyQAList) {
    return this.http.post(this.apiURL + '/api/BM/GetBMIncomingSurveyReport', obj, this.GetHttpOptions());
  }
  public getBMIncomingDashboard(obj: bmIncomingDashBoard) {
    return this.http.post(this.apiURL + '/api/BM/GetBMIncomingDashboard', obj, this.GetHttpOptions());
  }
  //BM Incoming Attendees

  public AddEditBMOutgoinngAttendee(objBMIncoming: bmincomingattendees) {
    return this.http.post(this.apiURL + '/api/BM/AddEditBMOutgoinngAttendee', objBMIncoming, this.GetHttpOptions());
  }

  public addEditBMIncomingAttendees(objBMIncoming: bmincomingattendees) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateBMIncomingAttendees', objBMIncoming, this.GetHttpOptions());
  }
  public addEditBMIncomingSurveyEntry(objKPI: BMIncomingSurveyEntry) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateBMIncomingSurveyEntry', objKPI, this.GetHttpOptions());
  }

  //survey option master
  public addEditSurveyOptionMaster(obj: surveyOptionMaster) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateSurveyOptionMaster', obj, this.GetHttpOptions());
  }
  public getSurveyOptionMaster(obj: surveyOptionMaster) {
    return this.http.post(this.apiURL + '/api/BM/GetSurveyOptionMaster', obj, this.GetHttpOptions());
  }
  public deleteSurveyOptionMaster(obj: surveyOptionMaster) {
    return this.http.post(this.apiURL + '/api/BM/DeleteSurveyOptionMaster', obj, this.GetHttpOptions());
  }

  public getSurveyOptionEntry(obj: surveyOptionMaster) {
    return this.http.post(this.apiURL + '/api/BM/GetSurveyOptionEntry', obj, this.GetHttpOptions());
  }
  public addEditSurveyOptionEntry(obj: surveyOptionEntry) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateSurveyOptionEntry', obj, this.GetHttpOptions());
  }

  //Survey Question Master
  public addEditSurveyQuestionMaster(obj: surveyQuestionMaster) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateSurveyQuestionMaster', obj, this.GetHttpOptions());
  }
  public deleteSurveyQuestionMaster(obj: surveyQuestionMaster) {
    return this.http.post(this.apiURL + '/api/BM/DeleteSurveyQuestionMaster', obj, this.GetHttpOptions());
  }
  public getSurveyQuestionMaster(obj: surveyQuestionMaster) {
    return this.http.post(this.apiURL + '/api/BM/GetSurveyQuestionMaster', obj, this.GetHttpOptions());
  }
  public addEditSurveyQuestionEntry(obj: surveyQuestionEntry) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateSurveyQuestionEntry', obj, this.GetHttpOptions());
  }
  public getSurveyQuestionEntry(obj: surveyQuestionEntry) {
    return this.http.post(this.apiURL + '/api/BM/GetSurveyQuestionEntry', obj, this.GetHttpOptions());
  }
  public getQuaterMaster(objquater: quater) {
    return this.http.post(this.apiURL + '/api/SLAKPI/GetQuaterMaster', objquater, this.GetHttpOptions());
  }

  //Annual Outgoing Visit
  public addEditAnnualOutingVisit(objBM: annualOutingVisit) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateAnnualOutingVisit', objBM, this.GetHttpOptions());
  }
  public getAnnualOutingVisit(objBM: annualOutingVisit) {
    return this.http.post(this.apiURL + '/api/BM/GetAnnualOutingVisit', objBM, this.GetHttpOptions());
  }
  public deleteAnnualOutingVisit(objBM: annualOutingVisit) {
    return this.http.post(this.apiURL + '/api/BM/DeleteAnnualOutingVisit', objBM, this.GetHttpOptions());
  }
  //Annual Performance BM
  public getAnnualStatus(obj: annualStatusHistroy) {
    return this.http.post(this.apiURL + '/api/BM/GetAnnualStatus', obj, this.GetHttpOptions());
  }
  public updateAnnualStatus(obj: annualStatusHistroy) {
    return this.http.post(this.apiURL + '/api/BM/UpdateAnnualStatus', obj, this.GetHttpOptions());
  }
  public getAnnualPerformanceBM(objBM: annualPerformanceBM) {
    return this.http.post(this.apiURL + '/api/BM/GetAnnualPerformaceBM', objBM, this.GetHttpOptions());
  }
  public addEditAnnualPerformanceBM(objBM: annualPerformanceBM) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateAnnualPerformaceBM', objBM, this.GetHttpOptions());
  }
  public deleteAnnualPerformanceBM(objBM: annualPerformanceBM) {
    return this.http.post(this.apiURL + '/api/BM/DeleteAnnualPerformaceBM', objBM, this.GetHttpOptions());
  }

  public addEditAnnualNomination(objBM: annualNomination) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateAnnualNomination', objBM, this.GetHttpOptions());
  }
  public getAnnualNomination(objBM: annualNomination) {
    return this.http.post(this.apiURL + '/api/BM/GetAnnualNomination', objBM, this.GetHttpOptions());
  }

  //Annual Practice BM
  public getAnnualPracticeBM(objBM: annualPracticeBM) {
    return this.http.post(this.apiURL + '/api/BM/GetAnnualPracticeBM', objBM, this.GetHttpOptions());
  }
  public addEditAnnualPracticeBM(objBM: annualPracticeBM) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateAnnualPracticeBM', objBM, this.GetHttpOptions());
  }
  public deleteAnnualPracticeBM(objBM: annualPracticeBM) {
    return this.http.post(this.apiURL + '/api/BM/DeleteAnnualPracticeBM', objBM, this.GetHttpOptions());
  }

  //Practice BM Progress Transaction
  public deletePracticeBMProject(objKPI: practicebmtransactionadd) {
    return this.http.post(this.apiURL + '/api/BM/DeletePracticeBMProject', objKPI, this.GetHttpOptions());
  }
  public getDashboardChart(obj: dashboardChart) {
    return this.http.post(this.apiURL + '/api/BM/GetDashboardChart', obj, this.GetHttpOptions());
  }
  public getPraticeBMDashboard(obj: dashboardContentEntry) {
    return this.http.post(this.apiURL + '/api/BM/GetPraticeBMDashboard', obj, this.GetHttpOptions());
  }
  public addEditPraticeBMDashboard(objKPI: dashboardContentEntry) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdatePraticeBMDashboard', objKPI, this.GetHttpOptions());
  }
  public getPracticeBMGranttChart(objDivision: practiceBMGranttChart) {
    return this.http.post(this.apiURL + '/api/BM/GetPracticeBMGranttChart', objDivision, this.GetHttpOptions());
  }
  public addEditPracticeBMProgress(objKPI: practicebmtransactionadd) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdatePracticeBMProgress', objKPI, this.GetHttpOptions());
  }
  public addBMProjectActions(objKPI: practicebmtransactionadd) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateBMProjectActions', objKPI, this.GetHttpOptions());
  }
  public getProjects(objDivision: practicebmtransactionadd) {
    return this.http.post(this.apiURL + '/api/BM/GetProjects', objDivision, this.GetHttpOptions());
  }
  public getAllAttachment(objDivision: BMProjectApprovalHistroy) {
    return this.http.post(this.apiURL + '/api/BM/GetAllAttachment', objDivision, this.GetHttpOptions());
  }
  public getProjectsApprovalHistroy(objDivision: BMProjectApprovalHistroy) {
    return this.http.post(this.apiURL + '/api/BM/GetProjectsApprovalHistroy', objDivision, this.GetHttpOptions());
  }
  public getProjectActions(objDivision: BMProjectActions) {
    return this.http.post(this.apiURL + '/api/BM/GetProjectActions', objDivision, this.GetHttpOptions());
  }
  public updateProjectApprovalOrReject(obj: BMProjectActions) {
    return this.http.post(this.apiURL + '/api/BM/UpdateProjectApprovalOrReject', obj, this.GetHttpOptions());
  }
  public assignUserUpdate(obj: benchmarkprogressmaster) {
    return this.http.post(this.apiURL + '/api/BM/UpdateAssignUser', obj, this.GetHttpOptions());
  }
  public deleteProgressBMProjectAction(objKPI: BMProjectActions) {
    return this.http.post(this.apiURL + '/api/BM/DeleteProgressBMProjectAction', objKPI, this.GetHttpOptions());
  }
  public progressBMProjectActionFileUpload(fileToUpload: any, fname: string, id: string) {

    let formData = new FormData();
    formData.append("file", fileToUpload);
    formData.append("name", fname);
    formData.append("id", id);
    let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.jwtToken() });
    let options = { headers: headers };
    return this.http.post(this.apiURL + '/api/BM/ProgressBMProjectActionFileUpload', formData, options)
  }

  public addEditBMProjectActionHistory(obj: BMProjectActionsHistory) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateBMProjectActionHistory', obj, this.GetHttpOptions());
  }
  public getBMProjectActionHistory(obj: BMProjectActionsHistory) {
    return this.http.post(this.apiURL + '/api/BM/GetBMProjectActionHistory', obj, this.GetHttpOptions());
  }
  public DownloadBMProjectActionHistoryFile(obj: BMProjectActionsHistory): Observable<any> {
    return this.http.post(this.apiURL + '/api/BM/DownloadBMProjectActionHistoryFile', obj, {
      responseType: "blob",
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.jwtToken()
      })
    });
  }

  //Outgoing BM Request Master

  public addEditOutgoingBMRequestMaster(obj: outgoingBMRequest) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateOutgoingBMRequestMaster', obj, this.GetHttpOptions());
  }
  public getOutgoingBMRequestMaster(obj: outgoingBMRequest) {
    return this.http.post(this.apiURL + '/api/BM/GetOutgoingBMRequestMaster', obj, this.GetHttpOptions());
  }
  public deleteOutgoingBMRequestMaster(obj: outgoingBMRequest) {
    return this.http.post(this.apiURL + '/api/BM/DeleteOutgoingBMRequestMaster', obj, this.GetHttpOptions());
  }

  //BM Request Master
  public addEdiBMRequestMaster(obj: bmRequest) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateBMRequestMaster', obj, this.GetHttpOptions());
  }
  public updateBMRequestStatus(obj: bmRequestStatusHistroy) {
    return this.http.post(this.apiURL + '/api/BM/UpdateBMRequestStatus', obj, this.GetHttpOptions());
  }
  public getBMRequestStatus(obj: bmRequestStatusHistroy) {
    return this.http.post(this.apiURL + '/api/BM/GetBMRequestStatus', obj, this.GetHttpOptions());
  }
  public getBMRequestMaster(obj: bmRequest) {
    return this.http.post(this.apiURL + '/api/BM/GetBMRequestMaster', obj, this.GetHttpOptions());
  }
  public deleteBMRequestMaster(obj: bmRequest) {
    return this.http.post(this.apiURL + '/api/BM/DeleteBMRequestMaster', obj, this.GetHttpOptions());
  }

  //Incoming Request Master
  public addEditIncomingBMRequestMaster(obj: incomingBMRequest) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateIncomingBMRequestMaster', obj, this.GetHttpOptions());
  }
  public getInComingBMRequestMaster(obj: incomingBMRequest) {
    return this.http.post(this.apiURL + '/api/BM/GetInComingBMRequestMaster', obj, this.GetHttpOptions());
  }
  public deleteInComingBMRequestMaster(obj: incomingBMRequest) {
    return this.http.post(this.apiURL + '/api/BM/DeleteInComingBMRequestMaster', obj, this.GetHttpOptions());
  }

  public fileManagerInsertUpdate(obj: any) {
    return this.http.post(this.apiURL + '/api/BM/FileManagerInsertUpdate', obj, this.GetHttpOptions());
  }

  public GetFileManagerList(obj: fileManager) {
    return this.http.post(this.apiURL + '/api/BM/GetFileManagerList', obj, this.GetHttpOptions());
  }

  public commonFileUpload(obj: any) {
    return this.http.post(this.apiURL + '/api/BM/CommonFileUpload', obj, this.httpOptions_file);
  }

  public getSurveyConfig(obj: surveyConfig) {
    return this.http.post(this.apiURL + '/api/BM/GetSurveyConfig', obj, this.GetHttpOptions());
  }
  public getRssFeed(obj: any) {
    return this.http.post(this.apiURL + '/api/BM/GetRSSFeed', obj, this.GetHttpOptions());
  }

 //Export
  public getKPIBenchmarkEntry_Export(obj: tranbenchmarkkpi) {
    return this.http.post(this.apiURL + '/api/BM/GetKPIBenchmarkEntry_Export', obj, this.GetHttpOptions());
  }
  public getTranBenchMarkKPIs_Export(objKPI: tranbenchmarkkpi) {
    return this.http.post(this.apiURL + '/api/BM/GetTranBenchMarkKPI_Export', objKPI, this.GetHttpOptions());
  }
  public downloadFileManagerFile(obj: fileManager): Observable<any> {
    return this.http.post(this.apiURL + '/api/BM/DownloadFileManagerFile', obj, {
      responseType: "blob",
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.jwtToken()
      })
    });
  }
  public getGeographicArea(objDivision: geographicArea) {
    return this.http.post(this.apiURL + '/api/Admin/GetGeographicArea', objDivision, this.GetHttpOptions());
  }
  public getProjectImportance(objDivision: projectImportance) {
    return this.http.post(this.apiURL + '/api/Admin/GetProjectImportance', objDivision, this.GetHttpOptions());
  }

  public addImportTranBenchMarkKPI(objImport: importtranbenchmarkkpi) {

    /* return this.http.post(this.apiURL + '/api/BM/InsertImportTranBenchMarkKPI', objImport, this.GetHttpOptions());*/
    return this._requestTextAPI(this.apiURL + '/api/BM/InsertImportTranBenchMarkKPI', objImport);
  }

  public BMOutgoingFileUpload(fileToUpload: any, fname: string, visitTrackUno: string) {
    
    let formData = new FormData();
    formData.append("file", fileToUpload);
    formData.append("name", visitTrackUno + "#" + fname);
    let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.jwtToken() });
    let options = { headers: headers };
    return this.http.post(this.apiURL + '/api/BM/BMOutgoing_FileUpload', formData, options)

  }

  public BMOutgoing_FileSelect(objBMOutgoing: filecontent) {
    
    return this.http.post(this.apiURL + '/api/BM/BMOutgoing_FileSelect', objBMOutgoing, this.GetHttpOptions());
  }

  public BMOutgoing_FileDelete(objBMOutgoing: filecontent) {
    return this.http.post(this.apiURL + '/api/BM/BMOutgoing_FileDelete', objBMOutgoing, this.GetHttpOptions());
  }

  public BMOutgoing_Filedownload(objBMOutgoing: filecontent): Observable<any> {
    return this.http.post(this.apiURL + '/api/BM/BMOutgoing_Filedownload', objBMOutgoing, {
      responseType: "blob",
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.jwtToken()
      })
    });
  }
  // Delegate Happines Master
  public AddEditDelegatesHappinessRateMaster(obj: delegatesHappinessMaster) {
    return this.http.post(this.apiURL + '/api/BM/InsertUpdateDelegatesHappinessRateMaster', obj, this.GetHttpOptions());
  }
  public getDelegatesHappinessRateMaster(obj: delegatesHappinessMaster) {
    return this.http.post(this.apiURL + '/api/BM/GetDelegatesHappinessRateMaster', obj, this.GetHttpOptions());
  }
  public deleteDelegatesHappinessRateMaster(obj: delegatesHappinessMaster) {
    return this.http.post(this.apiURL + '/api/BM/DeleteDelegatesHappinessRateMaster', obj, this.GetHttpOptions());
  }
  public BMEntryTemplateDownload(objBMOutgoing: filecontent): Observable<any> {
    return this.http.post(this.apiURL + '/api/BM/BMEntryTemplateDownload', objBMOutgoing, {
      responseType: "blob",
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.jwtToken()
      })
    });
  }
  // kpi year mapping
  public getKPIYearMappings(objsla: slakpiInteraction) {
    return this.http.post(this.apiURL + '/api/BM/GetKPIYearMapping', objsla, this.GetHttpOptions());
  }

  public addKPIYearMappings(objsla: slakpiMapping) {
    return this.http.post(this.apiURL + '/api/BM/AddKPIYearMapping', objsla, this.GetHttpOptions());
  }


  //public getKPI(objKPI: kpi) {
  //  
  //  return this.http.post(this.apiURL + '/api/SLAKPI/GetKPIs', objKPI, this.GetHttpOptions());
  //}

  public deleteKpiYearMappings(objsla: slakpiMapping) {
    
    return this.http.post(this.apiURL + '/api/BM/DeleteKPIYearMapping', objsla, this.GetHttpOptions());
  }
  public getKPI(objKPI: kpi) {
    
    return this.http.post(this.apiURL + '/api/BM/GetKPIs', objKPI, this.GetHttpOptions());
  }

  public addBenchMarkKPIEntry(objBMKpi: tranbenchmarkkpi) {
    return this._requestTextAPI(this.apiURL + '/api/BM/InsertBenchMarkKPIEntry', objBMKpi);
    //  return this.http.post(this.apiURL + '/api/BM/InsertBenchMarkKPIEntry', objBMKpi, this.GetHttpOptions());
  }

  public deleteBenchMarkKPIEntry(objBMKpi: tranbenchmarkkpi) {
    return this._requestTextAPI(this.apiURL + '/api/BM/DeleteBenchMarkKPIEntry', objBMKpi);
    //return this.http.post(this.apiURL + '/api/BM/DeleteBenchMarkKPIEntry', objBMKpi, this.GetHttpOptions());
  }
}
